import { usePropertyField } from '../usePropertyField';
import { IApplicationRental } from '@apply/api/src/api/ApplyApi';

// ─── Rental – Boolean Flags ───────────────────────────────────────────────────

export const usePropertyRentalIsAcquisitionFinancing = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.rental?.isAquisitionFinancing,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), isAquisitionFinancing: v } as IApplicationRental }));

export const usePropertyRentalMoreThan10kExpenditures = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.rental?.moreThan10kExpenditures,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), moreThan10kExpenditures: v } as IApplicationRental }));

export const usePropertyRentalIsLoanProceedsUsedPropertyImprovements = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.rental?.isLoanProceedsUsedPropertyImprovements,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), isLoanProceedsUsedPropertyImprovements: v } as IApplicationRental }));

export const usePropertyRentalPurchasedLessThan2YearsAgo = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.rental?.purchasedLessThan2YearsAgo,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), purchasedLessThan2YearsAgo: v } as IApplicationRental }));
